import { Injectable } from '@angular/core';
import { IIssue } from '@common/interfaces/issue';
import { Topics } from '@common/interfaces/topics';
import { ID } from '@common/interfaces/id';
import { ActiveState, EntityState, EntityStore, EntityUIStore } from '@datorama/akita';
import { PersistedStoreConfig } from '@persistence/persisted-store-config';
import { InterfaceNameValue } from '@common/interfaces/issueTypeInterface';

export type PendingState = 'done' | 'pending';

export type IssueUI = {
  id: ID;
  listPosition: number;
  performedBy?: ID;
  pendingState?: PendingState;
  openedInterface?: InterfaceNameValue[];
  //lastUpdatedByMe?: boolean;
};

export interface IssuesState extends EntityState<IIssue, ID>, ActiveState {}
export interface IssuesUIState extends EntityState<IssueUI, ID> {}

@Injectable({
  providedIn: 'root'
})
@PersistedStoreConfig({ name: Topics.ISSUES , realtimeEntity: 'issue', realtimeEntityAliases: ['Issue'], persistUiStore: true, persistence: 'external'})
export class IssueStore extends EntityStore<IssuesState> {

  ui: EntityUIStore<IssuesUIState>;
  constructor() {
    super();
    this.createUIStore().setInitialEntityState({ listPosition: 0, news: true, pendingState: 'done', openedInterface: [] });
  }
}
